export default "__VITE_ASSET__BydeVJqU__"